"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Error = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var styled_components_1 = __importDefault(require("styled-components"));
var Input_1 = __importDefault(require("../Input/Input"));
var Label_1 = __importDefault(require("../Label/Label"));
var InputIcon_1 = __importDefault(require("../InputIcon/InputIcon"));
var PasswordStrength_1 = __importDefault(require("../PasswordStrength/PasswordStrength"));
var successIcon = require('../../assets/img/check-small.svg');
var errorIcon = require('../../assets/img/error-small.svg');
var Row = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  margin-bottom: 35px;\n"], ["\n  position: relative;\n  margin-bottom: 35px;\n"])));
exports.Error = styled_components_1.default.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline-block;\n  position: absolute;\n  top: 55px;\n  left: 10px;\n  color: #da4725;\n  font-size: 12px;\n  font-family: Montserrat;\n"], ["\n  display: inline-block;\n  position: absolute;\n  top: 55px;\n  left: 10px;\n  color: #da4725;\n  font-size: 12px;\n  font-family: Montserrat;\n"])));
var FieldStatus = (0, styled_components_1.default)('span')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: block;\n  position: absolute;\n  top: 35px;\n  width: 15px;\n  height: 15px;\n  right: -25px;\n  background: url(", ")\n    no-repeat 50%;\n"], ["\n  display: block;\n  position: absolute;\n  top: 35px;\n  width: 15px;\n  height: 15px;\n  right: -25px;\n  background: url(", ")\n    no-repeat 50%;\n"])), function (props) {
    return props.status === 'error' ? errorIcon : successIcon;
});
FieldStatus.defaultProps = {
    status: 'success'
};
var ContentInput = function (_a) {
    var _b = _a.autoComplete, autoComplete = _b === void 0 ? '' : _b, _c = _a.placeholder, placeholder = _c === void 0 ? '' : _c, iconSrc = _a.iconSrc, id = _a.id, _d = _a.passwordStrength, passwordStrength = _d === void 0 ? '' : _d, _e = _a.strongPasswordMsg, strongPasswordMsg = _e === void 0 ? '' : _e, _f = _a.weakPasswordMsg, weakPasswordMsg = _f === void 0 ? '' : _f, label = _a.label, type = _a.type, value = _a.value, _g = _a.error, error = _g === void 0 ? '' : _g, _h = _a.status, status = _h === void 0 ? '' : _h, maxLength = _a.maxLength, handleChange = _a.handleChange, handleBlur = _a.handleBlur, handleFocus = _a.handleFocus, backgroundColor = _a.backgroundColor, autoFocus = _a.autoFocus, readonly = _a.readonly, rowStyle = _a.rowStyle;
    return (react_1.default.createElement(Row, { style: __assign({ opacity: readonly ? 0.5 : 1 }, rowStyle) },
        react_1.default.createElement(Label_1.default, { htmlFor: id }, label),
        react_1.default.createElement(Input_1.default, { autoComplete: autoComplete, readOnly: readonly, placeholder: placeholder, style: { backgroundColor: backgroundColor }, type: type, id: id, name: id, value: value, maxLength: maxLength, onChange: handleChange, onBlur: handleBlur, onFocus: handleFocus, autoFocus: autoFocus }),
        iconSrc && react_1.default.createElement(InputIcon_1.default, { url: iconSrc }),
        status && react_1.default.createElement(FieldStatus, { status: status }),
        !passwordStrength && react_1.default.createElement(exports.Error, null, error),
        passwordStrength && !error && (react_1.default.createElement(PasswordStrength_1.default, { strength: passwordStrength, strongPasswordMsg: strongPasswordMsg, weakPasswordMsg: weakPasswordMsg }))));
};
ContentInput.propTypes = {
    iconSrc: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.object]),
    id: prop_types_1.default.string.isRequired,
    passwordStrength: prop_types_1.default.string,
    strongPasswordMsg: prop_types_1.default.string,
    weakPasswordMsg: prop_types_1.default.string,
    type: prop_types_1.default.string.isRequired,
    error: prop_types_1.default.string,
    placeholder: prop_types_1.default.string,
    value: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
    maxLength: prop_types_1.default.number.isRequired,
    status: prop_types_1.default.string,
    handleChange: prop_types_1.default.func.isRequired,
    handleBlur: prop_types_1.default.func,
    handleFocus: prop_types_1.default.func,
    label: prop_types_1.default.string,
    backgroundColor: prop_types_1.default.string,
    autoFocus: prop_types_1.default.bool,
    rowStyle: prop_types_1.default.object
};
ContentInput.defaultProps = {
    iconSrc: '',
    passwordStrength: '',
    strongPasswordMsg: '',
    weakPasswordMsg: '',
    error: '',
    value: '',
    status: '',
    handleBlur: function () { },
    handleFocus: function () { },
    label: '',
    backgroundColor: '',
    autoFocus: false,
    rowStyle: {},
    readonly: false
};
exports.default = ContentInput;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=ContentInput.js.map